import config from '@/config'
import moment from 'moment'

export default {
  computed: {
    dateFormats () { return config.app.dateFormats }
  },

  methods: {
    /**
     * Format datetime to locale.
     * With fallback for IE which will output datetime in ISO 8601 with removed timezone part (YYYY-MM-DDTHH:mm:ss). IE fallback DST adjustment is calculated for North America period - local times change at 2:00 a.m. EST to 3:00 a.m. EDT on the second Sunday in March and return at 2:00 a.m. EDT to 1:00 a.m. EST on the first Sunday in November.
     * @param {Date} date - date to be converted to string
     * @param {String} [format=undefined] - optional format; will be parsed with moment.js
     */
    dateToLocaleDatetimeString (date, format) {
      let str = date.toString()
      if (typeof format === 'undefined' || format === null || format.length < 1) { format = this.dateFormats.longDateTime }

      try {
        str = date.toLocaleString('en-GB', { timeZone: this.dateFormats.localeTimezone }) // en-GB is like "30/06/2012, 01:00:00"
        let strParts = str.split(' ')
        str = str.substring(6, 10) + '-' + str.substring(3, 5) + '-' + str.substring(0, 2) + 'T' + strParts[1] // Datetime iso string 2019-10-29T14:07:07
      } catch (e) {
        let timeInLocale4StdTz = new Date(date.getTime() + (date.getTimezoneOffset() * 60000) + (this.dateFormats.localeTimezoneOffset.diffStd * 1000))
        let tzOffset = this.dateFormats.localeTimezoneOffset.diffStd

        if (this.dateFormats.localeTimezoneOffset.diffStd !== null && this.dateFormats.localeTimezoneOffset.diffDst !== this.dateFormats.localeTimezoneOffset.diffStd) {
          let dtUtcMonth = timeInLocale4StdTz.getMonth()
          switch (dtUtcMonth) {
            case 2:
              let sundayCount1 = 0
              let dayOfMarch = new Date(timeInLocale4StdTz.getTime())

              for (let d = 0; d <= 30 && d <= timeInLocale4StdTz.getDate(); d++) {
                dayOfMarch.setDate(d)
                if (dayOfMarch.getDay() === 0 && (d !== timeInLocale4StdTz.getDate() || timeInLocale4StdTz.getHours() > 2)) { sundayCount1++ }
              }

              if (sundayCount1 >= 2) { tzOffset = this.dateFormats.localeTimezoneOffset.diffDst }
              break
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
              tzOffset = this.dateFormats.localeTimezoneOffset.diffDst
              break
            case 10:
              let sundayCount2 = 0
              let dayOfNovember = new Date(timeInLocale4StdTz.getTime())

              for (let d = 0; d <= 29 && d <= timeInLocale4StdTz.getDate(); d++) {
                dayOfNovember.setDate(d)
                if (dayOfNovember.getDay() === 0 && (d !== timeInLocale4StdTz.getDate() || timeInLocale4StdTz.getHours() < 1)) { sundayCount2++ }
              }

              if (sundayCount2 === 0) { tzOffset = this.dateFormats.localeTimezoneOffset.diffDst }
              break
          }
        }

        let time4LocaleTz = new Date(date.getTime() + (tzOffset * 1000))
        str = time4LocaleTz.toISOString().substring(0, 19)
      }

      let mStr = moment(str)
      str = mStr.format(format)

      return str
    }
  },

  created () {
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Time.js